module.exports = __webpack_public_path__ + "img/icon-delete-round.253b5e16.svg";